import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-print-invoice',
  templateUrl: './print-invoice.component.html',
  styleUrls: ['./print-invoice.component.css']
})
export class PrintInvoiceComponent implements OnInit {
  public loading = false;
  public printInvoiceData: any;
  public projectData: any;
  public userDetails: any;
  public printInvoiceType: string = "";
  public QrCode: string = "";
  public projects: any;
  public orderType = '';
  public isCustomer = true;
  public balanceAmount: number;
  public isTurnOffPerPriceView = false;
  public isTurnOffImpressionCost = false;
  public isTurnOffSSInventory = false;
  public paymentHistory: any = [];
  public refundHistory: any = [];
  constructor(private router: Router) {
  }

  ngOnInit() {
    if (localStorage.getItem('printInvoiceData')) {

      this.printInvoiceData = JSON.parse(localStorage.getItem('printInvoiceData'));
      this.printInvoiceType = this.printInvoiceData.invoiceType;
      this.projectData = this.printInvoiceData.projectData;
      this.paymentHistory = this.printInvoiceData.paymentHistory;
      this.refundHistory = this.printInvoiceData.refundHistory;
      this.userDetails = localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails')) : {};

      if (this.printInvoiceData.invoiceType === 'BoxLabel') {
        const publicURL = window.location.origin + "/invoice/" + this.projectData.public_url_token;
        this.QrCode = publicURL;
        this.printInvoice();
      } else if (this.printInvoiceData.invoiceType === 'PrintInvoice') {
        this.projects =  this.projectData;
        this.orderType = this.projects.type;

        // Show/Hide line-items for price
        this.isTurnOffPerPriceView = this.projects.turn_off_price_per_peice && this.projects.turn_off_price_per_peice == '1' ? true : false;
        this.isTurnOffImpressionCost = this.projects.turn_off_impression_cost && this.projects.turn_off_impression_cost == '1' ? true : false;
        this.isTurnOffSSInventory = this.projects.turn_off_ss_inventory && this.projects.turn_off_ss_inventory == '1' ? true : false;


        // Due Amount calculation
        if (this.projects.paid_amount) {
          this.balanceAmount = (this.projects.grand_total_price - this.projects.paid_amount);
        } else {
          this.balanceAmount = (this.projects.grand_total_price);
        }
        if (this.projects.refunded_amount) {
          this.balanceAmount += Number(this.projects.refunded_amount);
        }
        this.printInvoice();
      } else if (this.printInvoiceData.invoiceType === 'WorkOrder') {
        this.projects =  this.projectData;
        this.orderType = this.projects.type;
        
        this.printInvoice();
      }
    } else {
      this.router.navigate(["/dashboard"]);
    }    
  }

  printInvoice() {
    setTimeout(() => {
      window.print();
    }, 1000);
  }

  callPrintInvoice() {
    this.printInvoice();
  }

  backToInvoice() {
    localStorage.removeItem("printInvoiceData");
    if(this.orderType == 'Invoice') {
      this.router.navigate([`/invoices/${this.projectData.order_id}`]);
    } else {
      this.router.navigate([`/quote/${this.projectData.order_id}`]);
    }
  }

  showCdrFile(urlname) {
    let urlExt = urlname.split('.').pop().toLowerCase();
    if (['cdr'].indexOf(urlExt) >= 0) {
      return 'assets/img/' + urlExt + '.png';
    }
    else {
      return urlname;
    }
  }

  checkSectionCustomItems = function (pKey, projectsData) {
    if (projectsData.custom_items && projectsData.custom_items.length > 0) {
      this.projects.projects_data[pKey]['section_items'] = [{
        'lable': "Section Title Click to Edit",
        'custom_items': projectsData.custom_items
      }];
    }
    if (projectsData.custom_items) {
      delete this.projects.projects_data[pKey].custom_items;
    }
    if (!this.projects.projects_data[pKey].section_items) {
      this.projects.projects_data[pKey]['section_items'] =
        [
          {
            'lable': "Section Title Click to Edit",
            'custom_items': [
              {
                item: "",
                price: "0",
                quantity: "0",
                description: ""
              }
            ]
          }
        ]
    }
    if (this.projects.projects_data[pKey].section_items && this.projects.projects_data[pKey].section_items.length == 0) {
      this.projects.projects_data[pKey]['section_items'].push(
        {
          'lable': "Section Title Click to Edit",
          'custom_items': [
            {
              item: "",
              price: "0",
              quantity: "0",
              description: ""
            }
          ]
        }
      )
    }
    return this.projects.projects_data[pKey].section_items;
  }

  getImpressionLocationCost(projectsData: any, printPositionKey: any): number {
    const activeProject = projectsData;

    if (activeProject && activeProject.priceDistributionData) {
      const distributionData = activeProject.priceDistributionData.find(
        (d) => d.printPositionKey === printPositionKey
      );

      return distributionData ? distributionData.perProductTotalPrintingCost : 0;
    }

    return 0;
  }

  totalQuantity = function (rowArr) {
    if (Object.keys(rowArr).length > 0) {
      return rowArr.reduce(function (a, b) {
        return a + b;
      }, 0);
    }
    else {
      return 0;
    }
  }

  calculateInventory(enteredQty, inStockQty, sizeIndex, colorId, productId) {
    let totalBalance = 0;
    let isproducExist = false;
    if (this.projects.projects_data.length > 1) {
      for (let i = 0; i < this.projects.projects_data.length; i++) {
        let products = (this.projects.projects_data[i].products) ? this.projects.projects_data[i].products.find(x => x.product_id === productId) : '';
        if (products) {
          for (let m = 0; m < products.matrix.length; m++) {
            if (products.matrix[m].color.color_id == colorId) {
              isproducExist = true;
              totalBalance += products.matrix[m].quantity[sizeIndex];
            }
            else {
              isproducExist = false;
              totalBalance = 0;
            }
          }
        }
      }
    }

    if (inStockQty != '') {
      let totaEnteredQty = isproducExist == true ? totalBalance : enteredQty;
      return (inStockQty - totaEnteredQty);
    }
    else {
      return 0;
    }
  }

  removeString(transId, type) {
    let chequNo = type == 'Cheque' ? '(Check No: ' + transId.replace('Cheque_', '') + ')' : '';
    return chequNo;
  }

  convertToNumber(value) {
    return Number(value);
  }

  getTaxDisplay(taxExempt: boolean, tax: string | number): string {
    const taxValue = parseFloat(tax as string);
    if (taxExempt && taxValue === 0) {
      return 'Tax Exempt';
    } else {
      return `$${taxValue.toFixed(2)}`;
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/print-invoice/print-invoice.component.ts